import { z } from 'zod'

const RunbookTaskSchema = z.object({
    id: z.number().nullable().optional(),
    taskNo: z.number().int().nullable().optional(),
    task: z.string().min(1, 'Task name is required'),
    commands: z.string().optional().nullable(),
    duration: z.number().int().min(0).default(0),
    taskOffset: z.number().int().nullable().optional(),
    dependencies: z.string().optional().nullable(),
    startTime: z.string().nullable().optional(), // Deprecated, kept for compatibility
    finishTime: z.string().nullable().optional(), // Deprecated, kept for compatibility
})

export const masterRunbookSchema = z.object({
    description: z.string().min(1, 'Description is required'),
    information: z.string().optional().nullable(),
    tasks: z.array(RunbookTaskSchema).optional().default([]),
})

export type MasterRunbookFormData = z.infer<typeof masterRunbookSchema>
